import type { Faq } from '../services/faqService'

export function filterFaqs<T extends Pick<Faq, 'title' | 'content'>>(items: T[], query: string): T[] {
  const value = query.trim().toLowerCase()
  if (!value) return items

  return items.filter((it) => {
    const title = (it.title ?? '').toLowerCase()
    const content = (it.content ?? '').toLowerCase()
    return title.includes(value) || content.includes(value)
  })
}
